/**
 * attraction — real narrated point.
 * waypoint — silent geometry for the walking polyline; never content or a player stop.
 */
export enum ReadyRouteStopKindEnum {
    ATTRACTION = 'attraction',
    ESTABLISHMENT = 'establishment',
    WAYPOINT = 'waypoint',
}
